import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';
// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
// Helpers de formulário
import InputMask from 'react-input-mask';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';

import BaseYearPeriodDayEditModal from './BaseYearPeriodDayEditModal';
import BaseYearPeriodDaysReformModal from './BaseYearPeriodDaysReformModal';

class BaseYearPeriodDays extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      modal_day_props: false,
      modal_props: false,
      loaded: 0,
      date_start: null,
      mis_days: null,
      fr_days: null,
      name: null,
      related_base_year_period_id: null,
      date_day_modal: null,
      replicate_base_year_period_id: null,
      replicate_date_start: null,
      data_base_year_period_day_type: null,
      data_base_year_period_day_id: null,
      types_list: [],
      base_year_period_lists: [],
      base_year_period_id: this.props.base_year_period.id,
      base_year_period_days: [],
      data_period_modal: [],
    };

    //bind específico
    this.replicate = this.replicate.bind(this);
    this.editPeriod = this.editPeriod.bind(this);
    this.modalPropsOff = this.modalPropsOff.bind(this);
    this.showModal = this.showModal.bind(this);
    this.showModalDate = this.showModalDate.bind(this);
    this.ActionsButtons = this.ActionsButtons.bind(this);
    this.deletePeriod = this.deletePeriod.bind(this);
  }
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  // LM
  componentWillReceiveProps(newProps) {
    if((this.state.loaded === 0 && typeof newProps.base_year_period.id !== 'undefined' && Array.isArray(newProps.base_year_period.base_year_period_days)) || (this.state.loaded === 1 && newProps.updated === 1)) {
      this.setState({
        base_year_period: newProps.base_year_period,
        date_start: newProps.base_year_period.date_start_str,
        mis_days: newProps.base_year_period.mis_days,
        fr_days: newProps.base_year_period.fr_days,
        base_year_period_id: newProps.base_year_period.id,
        name: newProps.base_year_period.name,
        related_base_year_id: newProps.base_year_period.base_year_id,
        related_base_year_period_id: newProps.base_year_period.base_year_period_id,
        team_rubi: newProps.base_year_period.team_rubi,
        schedule_rubi: newProps.base_year_period.schedule_rubi,
        base_year_period_days: newProps.base_year_period.base_year_period_days,
        types_list: newProps.types_list,
      });
    }
    if((Array.isArray(newProps.base_year_period_lists)) || (this.state.loaded === 1 && newProps.updated === 1)) {
      this.setState({
        base_year_period_lists: newProps.base_year_period_lists,
      });
    }
  }

  deletePeriod() {
    var confirm = window.confirm('Tem certeza que deseja deletar esse período?');
    if (confirm) {
      var self = this;
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/base/ano/periodo/' + self.state.base_year_period_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.updateData(responseJson);
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }


  editPeriod(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      base_year_period_id: this.state.base_year_period_id,
      name: this.state.name,
      date_start: this.state.date_start,
      mis_days: this.state.mis_days,
      fr_days: this.state.fr_days,
      schedule_rubi: this.state.schedule_rubi,
      team_rubi: this.state.team_rubi,
      related_base_year_period_id: this.state.related_base_year_period_id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/base/ano/periodo', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.updateData(responseJson);
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  replicate() {
    if(window.confirm('Tem certeza que deseja replicar esse período para o ano seguinte?')) {
      this.props.handleAlert('', '', 'open');
      var datasave = {
        base_year_period_id: this.state.base_year_period_id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/base/ano/periodo/replicar', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.updateData(responseJson);
          self.modalPropsOff();
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  showModalDate (value, event) {
   this.setState({
      data_base_year_period_day_id: value.currentTarget.id,
      data_base_year_period_day_type: value.currentTarget.value,
      modal_day_props: true,
    });
  }

  showModal (value, event) {
    this.setState({
      date_day_modal: value.currentTarget.value,
      data_period_modal: this.state.base_year_period,
      modal_props: true,
    });
  }


  modalPropsOff (event) {
    this.setState({ modal_props: false});
    this.setState({ modal_day_props: false});
  }


  ActionsButtons (cell, row) {
    var botao = (
      <div className="btn-group">
        <button className="btn btn-sm btn-primary" value={row.type} id={row.id} onClick={this.showModalDate}>
          <i className="fa fa-fw fa-pencil"></i>
        </button>
        <button className="btn btn-sm btn-warning" value={cell} onClick={this.showModal}>
          <i className="fa fa-fw fa-refresh"></i>
        </button>
      </div>
    );

    return botao;
  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <hr/>
  <form onSubmit={this.editPeriod}>
    <div className="row">
      <div className="col-md-3 form-group">
        <label>Nome:</label>
          <input type="text" className="form-control" name="name" value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
      </div>
      <div className="col-md-3 form-group">
        <label>Data inicial:</label>
        <InputMask value={this.state.date_start}  maskChar={null} name="date_start" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_start')} placeholder="" />
      </div>
      <div className="col-md-3 form-group">
        <label>Dias de missão:</label>
        <input type="number" className="form-control" name="mis_days" value={this.state.mis_days} placeholder="" onChange={this.handleChange.bind(this, 'mis_days')} />
      </div>
      <div className="col-md-3 form-group">
        <label>Dias de folga:</label>
        <input type="number" className="form-control" name="fr_days" value={this.state.fr_days} placeholder="" onChange={this.handleChange.bind(this, 'fr_days')} />
      </div>
    </div>
    <div className="row">
      <div className="col-md-4">
        <div className="form-group">
          <label>Selecione o período relacionado do próximo ano:</label>
          <Select
            className="form-field-name"
            name="related_base_year_period_id"
            value={this.state.related_base_year_period_id}
            searchable={true}
            placeholder={'Selecionar período'}
            onChange={this.handleSelectChange.bind(this, 'related_base_year_period_id')}
            options={this.state.base_year_period_lists}
          />
        </div>
      </div>
      <div className="col-md-4">
        <div className="form-group">
          <label>Id Escala - Rubi:</label>
          <input type="text" name="schedule_rubi" className="form-control" placeholder="Id Escala - Rubi" value={self.state.schedule_rubi} onChange={this.handleChange.bind(this, 'schedule_rubi')} />
        </div>
      </div>
      <div className="col-md-4">
        <div className="form-group">
          <label>Id Turma - Rubi:</label>
          <input type="text" name="team_rubi" className="form-control" placeholder="Id Turma - Rubi" value={self.state.team_rubi} onChange={this.handleChange.bind(this, 'team_rubi')} />
        </div>
      </div>
    </div>
    <button type={'submit'} className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Editar período</button>
  </form>
  <hr/>
  <h3 className="pull-left">{self.state.name}</h3>
  <button className="btn btn-warning pull-right" onClick={() => this.replicate()}><i className="fa fa-fw fa-refresh"></i> Replicar para o ano seguinte</button>
  <button className="btn btn-danger pull-right button-inline" onClick={this.deletePeriod}><i className="fa fa-fw fa-trash"></i> Deletar período personalizado</button>
  <div className="clearfix"></div>
  <hr/>
  <h4>Calendário</h4>
  <BootstrapTable data={this.state.base_year_period_days} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', noDataText: 'Não há bases cadastradas'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>
    <TableHeaderColumn dataField="month" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Mês</TableHeaderColumn>

    <TableHeaderColumn dataField="date_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Data</TableHeaderColumn>

    <TableHeaderColumn dataField="type" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Tipo</TableHeaderColumn>

    <TableHeaderColumn dataField="date_str" dataAlign="center" dataFormat={this.ActionsButtons} width='120'>Ações</TableHeaderColumn>

  </BootstrapTable>
  <BaseYearPeriodDayEditModal updateData={self.props.updateData} handleAlert={self.props.handleAlert} updated={self.props.updated} modalPropsOff={self.modalPropsOff} loadData={self.props.loadData} modal_props={self.state.modal_day_props} data_base_year_period_day_type={self.state.data_base_year_period_day_type} data_base_year_period_day_id={self.state.data_base_year_period_day_id}/>
  <BaseYearPeriodDaysReformModal updateData={self.props.updateData} handleAlert={self.props.handleAlert} updated={self.props.updated} modalPropsOff={self.modalPropsOff} loadData={self.props.loadData} modal_props={self.state.modal_props} date_day_modal={self.state.date_day_modal} data_period_modal={self.state.data_period_modal} />
</div>
    );
  }
}

export default BaseYearPeriodDays;



// WEBPACK FOOTER //
// ./src/Components/Bases/Elements/BaseYearPeriodDays.js